export default "__VITE_ASSET__DXBKgT_7__"